export default function Modal({ title, onClose, children, gradient = false, headerAction = null }) {
    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0,0,0,0.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
        }}>
            <div
                style={{
                    background: gradient
                        ? 'linear-gradient(180deg, #ede9fe 0%, #ffffff 160px)'
                        : 'white',
                    borderRadius: '12px',
                    padding: '28px',
                    width: '100%',
                    maxWidth: '480px',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                }}
            >
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '24px',
                }}>
                    <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '700' }}>
                        {title}
                    </h2>
                    {headerAction}
                    <button
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '22px',
                            cursor: 'pointer',
                            color: '#888',
                            lineHeight: 1,
                        }}
                    >
                        ×
                    </button>
                </div>
                {children}
            </div>
        </div>
    );
}